import i18n from '@/lib/i18n';
import ErrorDispatcher from './ErrorDispatcher';

export class QuestionResolutionError extends Error implements ErrorDispatcher {
  constructor() {
    super(
      i18n.t(
        'courseLineForm.questionsTab.createQuestionModal.resolveQuestionError',
      ),
    );
    this.name = 'QuestionResolutionError';
    Object.setPrototypeOf(this, QuestionResolutionError.prototype);
  }

  getError(): Error {
    return this;
  }
}
